<div class="whitelist-item-head" [ngClass]="labelStatus">
  <div class="ba-list-head">
    <div class="row">
      <div class="col-md-4">
        <span>
          BA
          <a uiSref="a.business_order.view" [uiParams]="{id:businessOrder.id, index:businessOrder.index}">
            {{ businessOrder.id }}-{{ businessOrder.index }}
          </a> - {{ labelText }}
        </span>
        @if (businessOrder.status !== 0) {
          <ev-file-button [url]="businessOrderUri" [link]="false">
            <i class="fa fa-file-pdf-o" aria-hidden="true" title="BA PDF öffnen"></i>
          </ev-file-button>
        }
        <span class="ba-label-spacer">&nbsp;</span>
        <business-order-label [surface]="article.data.surface_area"
                              [empb]="!!empb && !!businessOrder.first_contract"
                              [kanban]="!!kanban"
                              [hasPlugging]="businessOrder.has_plugging"
                              [hasCopperFilling]="businessOrder.has_copper_filling"
                              [hasReproduction]="!!businessOrder.reproduction"
                              [willBeMerged]="!!businessOrder.reproduction?.will_be_merged ||
                               ((businessOrder.reproduction?.step_ordering ?? null) !== null)"
                              [hasBlindHole]="!!article.data.blind_hole_tech_ls || !!article.data.blind_hole_tech_ds">
        </business-order-label>
      </div>

      <div class="col-md-4">
        @if (businessOrder.status === 4 && hashesAreValid) {
          <div class="ml-10">
            Fortschritt: {{ businessOrder.percent }} %
          </div>
        }
        @if (businessOrder.status === 4 && !hashesAreValid) {
          <div class="ml-10">
            Abweichung zum aktuellen Artikel möglich
          </div>
        }
      </div>

      <div class="col-md-4">
        @if (businessOrder.status === 0) {
          <div class="pull-right start-storno-controls">
            @if (('ba.start'|HasPerm)) {
              <button type="button" class="btn btn-sm btn-link" (click)="start()">
                Starten
              </button>
            }
          </div>
        }
        @if (businessOrder.status >= 0 && businessOrder.status <= 4) {
          <div class="pull-right start-storno-controls">
            @if (businessOrder.status <= 1 && ('business_order.storno'|HasPerm)) {
              <button type="button" class="btn btn-sm btn-link"
                (click)="storno()"
                >
                Stornieren
              </button>
            }
          </div>
        }
        @if (canSelectReproduction) {
          <div class="pull-right start-storno-controls">
            @if (('ba.start'|HasPerm)) {
              <button type="button"
                class="btn btn-sm btn-link"
                (click)="selectReproduction()"
                >
                Nachfertigung
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-12">

    <table class="table inBoxtable">
      <tr>
        <th>Vorgang</th>
        <th>AT</th>
        <th>Start-Termin</th>
        <th>End-Termin</th>
        <th>Nutzen</th>
        <th>Best. Menge</th>
        <th>
          @if (businessOrder.status === 1 && !businessOrder.applied_material) {
            <span>Vorgabe Material</span>
          }
          @if (businessOrder.status !== 0 && businessOrder.applied_material) {
            <span>Material</span>
          }
        </th>
        @if (businessOrder.status === 1) {
          <th>Produktions-Schritt</th>
        }
        @if (businessOrder.status === 1|| businessOrder.status === 2) {
          <th>Gutstück</th>
        }
        @if (businessOrder.status === 4) {
          <th>Fertigstellung</th>
        }
      </tr>
      <tr>
        <td>
          <a uiSref="a.workflow.detail" [uiParams]="{id: businessOrder.workflow_id}">
            @if (isSameWorkflow) {
              <span class="label label-info">{{ businessOrder.workflow_id }}</span>
            }
            @if (!isSameWorkflow) {
              <span>{{ businessOrder.workflow_id }}</span>
            }
          </a>
        </td>
        <td>
          <span [ngClass]="{label: businessOrder.express, 'label-purple': businessOrder.express}">
            {{ businessOrder.work_days }}
          </span>
        </td>
        <td>{{ businessOrder.start_date }} / {{ businessOrder.start_week }}</td>
        <td>{{ businessOrder.end_date }} / {{ businessOrder.end_week }}</td>
        <td>{{ businessOrder.utilize_quantity|money }}</td>
        <td>{{ businessOrder.quantity|money }}</td>
        <td>
          @if (businessOrder.status === 1 && businessOrder.target_material && !businessOrder.applied_material) {
            <span>
              {{ businessOrder.target_material }}
            </span>
          }
          @if (businessOrder.status === 1 && !businessOrder.target_material && !businessOrder.applied_material) {
            <span>
              -
            </span>
          }
          @if (businessOrder.status !== 0 && businessOrder.applied_material) {
            <span>
              {{ businessOrder.applied_material }}
            </span>
          }
        </td>
        @if (businessOrder.status === 1) {
          <td>
            @if (businessOrder.current_step) {
              <span>{{ businessOrder.current_step }}</span>
            }
            @if (!businessOrder.current_step) {
              <span>-</span>
            }
          </td>
        }
        @if (businessOrder.status >= 1 && businessOrder.status <= 4) {
          <td>
            @if (businessOrder.good_piece) {
              <span>{{ businessOrder.good_piece }}</span>
            }
            @if (!businessOrder.good_piece) {
              <span>-</span>
            }
          </td>
        }
        @if (businessOrder.status >= 2 && businessOrder.status <= 4) {
          <td>{{ businessOrder.date_finished }}</td>
        }
      </tr>
      @if (businessOrder.custom_delivery_quantities && !!businessOrder.custom_delivery_note) {
        <tr>
          <td colspan="10"><b>Spezifische Unter-/Überlieferung:</b>&nbsp;{{businessOrder.custom_delivery_note}}</td>
        </tr>
      }
    </table>

  </div>
</div>

@if (!!businessOrder.reproduction) {
  <div class="row">
    <div class="col-sm-6">
      <strong>{{businessOrder.reproduction.reason}}</strong> - {{businessOrder.reproduction.note}}
    </div>
    @if (!!businessOrder.reproduction.step_name) {
      <div class="col-sm-6">
        Zusammenfügung in Schritt: <strong>{{businessOrder.reproduction.step_name}}</strong>
      </div>
    }
  </div>
}
